export enum StatusLightColorsEnum {
  GREEN = 'surface-success',
  RED = 'surface-error',
  YELLOW = 'surface-warning',
  BLUE = 'surface-brand',
  GRAY = 'status-light-gray-background',
}
